import * as React from 'react';
import Context from '../../State/Context';
import { IUsageSelector } from '../../Types/Datasources';
import {
    EPage,
    ESourceType,
} from '../../Types/Model';
import Markdown from '../Markdown';
import SectionOther from '../SectionOther';
import TotalFooter from '../TotalFooter';
import UsageSelector from '../UsageSelector';

export default class IndustrialAndCommercial extends React.Component {
    public render() {
        return (
            <Context.Consumer>
                {({
                    getTotal,
                    activities, 
                    messages, 
                    userState, 
                    onToggleOption,
                    onAddActivity,
                    onAddOtherActivity,
                    onChangeActivityName,
                    onChangeActivityValue,
                    onChangeOtherActivityName,
                    onChangeOtherActivityValue,
                 }) => {
                    const {
                        activitySelections: selections,
                        otherActivitySelections,
                        enabledOptions,
                    } = userState;

                    const usageSelectorData: IUsageSelector = {
                        onAdd: onAddActivity,
                        onAddOther: onAddOtherActivity,
                        onChangeName: onChangeActivityName,
                        onChangeOtherName: onChangeOtherActivityName,
                        onChangeOtherValue: onChangeOtherActivityValue,
                        onChangeValue: onChangeActivityValue,
                        options: activities.map(item => item.name),
                        otherActivitySelections,
                        selections,
                    };

                    const onToggleEnable = () => onToggleOption(ESourceType.OtherActivity, !isEnabled(ESourceType.OtherActivity));
                    const isEnabled = (type: ESourceType) => enabledOptions.indexOf(type) > -1;

                    const {
                        title, 
                        description,
                        buttonAddAnotherActivity,
                        buttonAddAnotherOther,
                        headingTotal,
                        labelDescription,
                        labelNumberOfUnits,
                        labelTotalKilolitresPerAnnum,
                        labelTypeOfActivity,
                        labelOther,
                        tooltipOther,
                    } = messages.page4;

                    const total = getTotal(EPage.IndustrialAndCommercial) + ' kL';

                    return (
                        <div>
                            <h2>{title}</h2>
                            <Markdown source={description}/>
                            <UsageSelector
                                title=""
                                headers={[labelTypeOfActivity, labelNumberOfUnits]} 
                                defaultOption={{ id: '', label: buttonAddAnotherActivity, value: '' }} 
                                {...usageSelectorData}
                            />
                            <hr className="gray"/>
                            <SectionOther
                                buttonAddText={buttonAddAnotherOther}
                                enabled={isEnabled(ESourceType.OtherActivity)}
                                headers={[labelDescription, labelTotalKilolitresPerAnnum]} 
                                labelOther={labelOther}
                                onToggleEnable={onToggleEnable}
                                {...usageSelectorData}
                                tooltip={tooltipOther}
                            />
                            <hr className="green"/>
                            <TotalFooter label={headingTotal} total={total} />
                        </div>
                    );
                }}
            </Context.Consumer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Pages/IndustrialAndCommercial.tsx